module.exports = {
  test:'测试'
}